
import Vue from "vue";
import {ApplicationEventKey, ApplicationHistoryEventModel, RequirementViewModel} from "@/api-client";
import {Prop} from "vue-property-decorator";
import Component from "vue-class-component";
import {Location} from "vue-router";

@Component(
    {
        components: {}
    })

export default class HistoryEvent extends Vue {
    @Prop({required: true})
    historyEvent!: ApplicationHistoryEventModel;

    @Prop({ required: true})
    requirement! : RequirementViewModel | null;

    @Prop({required: true})
    showRequirementLink!: boolean;

    getIconClass(key: ApplicationEventKey) {
        switch (key) {
            case ApplicationEventKey.Started:
                return "fas fa-folder-plus";
            case ApplicationEventKey.Submitted:
                return "fas fa-arrow-circle-right";
            case ApplicationEventKey.ProcessingStarted:
                return "fas fa-tasks";
            case ApplicationEventKey.Rejected:
                return "fas fa-exclamation-triangle";
            case ApplicationEventKey.DocumentIssued:
                return "fas fa-check-circle";
            case ApplicationEventKey.Archived:
                return "fas fa-folder";
            case ApplicationEventKey.Change:
                return "fas fa-pen text-warning";
            case ApplicationEventKey.Deleted:
                return "fas fa-trash";
            default:
        }
    }
    
    get hasRequirementLink(): boolean {
        return this.historyEvent?.requirementId !== null
            && this.$router.currentRoute.name !== "RequirementOverview";
    }

    get requirementLink(): Location {
        return {
            name: "RequirementOverview",
            params: {requirementId: this.historyEvent.requirementId!}
        }
    }
}

